(function () {
  'use strict';

  // ─── Delivery Sort ────────────────────────────────────────────────────────

  function extractMinWeeks(card) {
    const deliveryNote = card.querySelector('.custom-delivery-note p');
    if (!deliveryNote) return 999;
    const match = deliveryNote.textContent.trim().match(/(\d+)/);
    return match ? parseInt(match[1], 10) : 999;
  }

  function sortByDelivery() {
    const urlParams = new URLSearchParams(window.location.search);
    const sortByParam = urlParams.get('sort_by');

    // If a real Shopify sort is active, skip
    if (sortByParam && sortByParam !== 'fastest-delivery') return;

    // If any filter is active, skip
    for (const [key] of urlParams) {
      if (key.startsWith('filter.')) return;
    }

    const productGrid = document.getElementById('product-grid');
    if (!productGrid || productGrid.children.length === 0) return;

    const cards = Array.from(productGrid.children);
    cards.sort((a, b) => extractMinWeeks(a) - extractMinWeeks(b));

    const fragment = document.createDocumentFragment();
    cards.forEach(card => fragment.appendChild(card));
    productGrid.appendChild(fragment);
  }

  // ─── Sync mobile sort drawer selected state ───────────────────────────────
  // The drawer lives outside ProductGridContainer so facets.js never updates
  // its selected state after an AJAX re-render. We do it manually here by
  // reading the current sort_by from the URL after every render.

  function syncMobileSortDrawer() {
    const urlParams = new URLSearchParams(window.location.search);
    const sortByParam = urlParams.get('sort_by');

    // Determine which value is currently active:
    // - If no sort_by in URL and fastest delivery is available → fastest-delivery
    // - Otherwise → whatever sort_by is in the URL
    const fastestDeliveryBtn = document.querySelector(
      '.mobile-facets__sort-drawer-option[data-value="fastest-delivery"]'
    );
    const isFastestDeliveryActive = !sortByParam && !!fastestDeliveryBtn;
    const activeValue = isFastestDeliveryActive ? 'fastest-delivery' : (sortByParam || 'manual');

    document.querySelectorAll('.mobile-facets__sort-drawer-option').forEach(btn => {
      if (btn.dataset.value === activeValue) {
        btn.classList.add('selected');
      } else {
        btn.classList.remove('selected');
      }
    });
  }

  // ─── Handle "Fastest Delivery" option clicks ──────────────────────────────
  // NOTE: All other sort option clicks are handled entirely by facets.js.
  // This only covers the custom "Fastest Delivery" option which is not a
  // real Shopify sort_by value and therefore needs its own handling.

  function handleFastestDeliveryClick(optionEl) {
    // Update selected state visually
    const container = optionEl.closest('.facets__sort-dropdown, .mobile-facets__sort-drawer-options');
    if (container) {
      container.querySelectorAll('.facets__sort-option, .mobile-facets__sort-drawer-option')
        .forEach(el => el.classList.remove('selected'));
      optionEl.classList.add('selected');
    }

    // Update desktop summary label
    const details = optionEl.closest('details');
    if (details) {
      const label = details.querySelector('.facets__sort-button span');
      if (label) label.textContent = 'Fastest Delivery';
      details.removeAttribute('open');
    }

    // Close mobile sort drawer if open
    const drawer = document.querySelector('[data-mobile-sort-drawer]');
    const overlay = document.querySelector('[data-mobile-sort-overlay]');
    if (drawer) drawer.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';

    // Remove sort_by from URL so no real Shopify sort is active,
    // then re-render via Shopify's FacetFiltersForm
    const url = new URL(window.location.href);
    url.searchParams.delete('sort_by');
    const searchParams = url.searchParams.toString();

    if (typeof FacetFiltersForm !== 'undefined') {
      FacetFiltersForm.renderPage(searchParams, null, true);
    } else {
      window.history.pushState({}, '', url.toString());
      sortByDelivery();
    }
  }

  // ─── Attach click handler ONLY to Fastest Delivery options ───────────────

  function attachFastestDeliveryHandler() {
    document.querySelectorAll(
      '.facets__sort-option[data-value="fastest-delivery"], .mobile-facets__sort-drawer-option[data-value="fastest-delivery"]'
    ).forEach(el => {
      if (el.dataset.deliveryBound) return; // avoid double-binding
      el.dataset.deliveryBound = '1';
      el.addEventListener('click', function (e) {
        // stopImmediatePropagation prevents facets.js from ALSO handling
        // this click and firing a competing renderPage call
        e.stopImmediatePropagation();
        handleFastestDeliveryClick(this);
      });
    });
  }

  // ─── Hook into Shopify facets re-render ───────────────────────────────────
  // We only wrap renderProductGridContainer — the method that replaces the
  // grid HTML. After it runs we: re-apply delivery sort if needed, re-bind
  // the Fastest Delivery button, and sync the mobile drawer selected state.

  function hookFacetFiltersForm() {
    let attempts = 0;
    const interval = setInterval(() => {
      attempts++;

      if (typeof FacetFiltersForm !== 'undefined') {
        clearInterval(interval);

        const originalRender = FacetFiltersForm.renderProductGridContainer;
        FacetFiltersForm.renderProductGridContainer = function (html) {
          originalRender.call(this, html);
          setTimeout(() => {
            sortByDelivery();
            attachFastestDeliveryHandler();
            syncMobileSortDrawer();
          }, 100);
        };

      } else if (attempts > 100) {
        clearInterval(interval);
      }
    }, 100);
  }

  // ─── Init ─────────────────────────────────────────────────────────────────

  function init() {
    sortByDelivery();
    attachFastestDeliveryHandler();
    syncMobileSortDrawer();
    hookFacetFiltersForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();